import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=50a0b6d4"
import script from "./AddCoupon.vue?vue&type=script&lang=js"
export * from "./AddCoupon.vue?vue&type=script&lang=js"
import style0 from "./AddCoupon.vue?vue&type=style&index=0&id=50a0b6d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports